export var ToolOutcome;
(function (ToolOutcome) {
    ToolOutcome["SUCCESS"] = "success";
    ToolOutcome["FAILURE"] = "failure";
    ToolOutcome["PARTIAL"] = "partial";
})(ToolOutcome || (ToolOutcome = {}));
export var ToolStatus;
(function (ToolStatus) {
    ToolStatus["PENDING"] = "pending";
    ToolStatus["RUNNING"] = "running";
    ToolStatus["SUCCESS"] = "success";
    ToolStatus["FAILURE"] = "failure";
    ToolStatus["PARTIAL"] = "partial";
})(ToolStatus || (ToolStatus = {}));
